// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 260px;
  background-color: var(--bg-sidebar);
  border-right: 1px solid var(--border-subtle);
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 24px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  overflow-y: auto;
}

/* ── Brand logo ── */
.sidebar__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.sidebar__logo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3px;
  width: 22px;
  height: 22px;
}

.sidebar__logo-dot {
  background-color: var(--accent-emerald);
  border-radius: 2px;
  transition: all 0.3s ease;
}

.sidebar__brand:hover .sidebar__logo-dot {
  transform: scale(1.1);
  filter: drop-shadow(0 0 4px var(--accent-emerald));
}

.sidebar__brand-name {
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 1.35rem;
  color: var(--text-primary);
  letter-spacing: -0.5px;
}

/* ── Sidebar Search ── */
.sidebar__search-container {
  margin-bottom: 20px;
}

.sidebar__search-wrapper {
  position: relative;
  width: 100%;
}

.sidebar__search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.sidebar__search-input {
  width: 100%;
  padding: 10px 12px 10px 38px;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-family: var(--font-sans);
  transition: all 0.3s ease;
}

.sidebar__search-input:focus {
  border-color: var(--border-active);
  background: var(--bg-glass-hover);
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.08);
  outline: none;
}

/* ── Navigation Links ── */
.sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.sidebar__menu-group {
  display: flex;
  flex-direction: column;
}

.sidebar__nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 12px;
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
}

.sidebar__nav-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar__nav-item:hover {
  background: var(--bg-glass-hover);
  color: var(--text-primary);
}

.sidebar__nav-item--parent.expanded {
  color: var(--text-primary);
}

.sidebar__nav-item-icon {
  transition: transform 0.3s ease;
}

.sidebar__nav-item:hover .sidebar__nav-item-icon {
  transform: translateX(1px);
}

.sidebar__arrow {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-muted);
}

.sidebar__arrow.rotated {
  transform: rotate(180deg);
  color: var(--text-primary);
}

/* Sub Navigation Menu */
.sidebar__sub-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 28px;
  margin-top: 4px;
  border-left: 1px solid var(--border-subtle);
  margin-left: 20px;
}

.sidebar__sub-nav-item {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  font-size: 0.88rem;
  font-weight: 400;
  transition: all 0.2s ease;
}

.sidebar__sub-nav-item:hover {
  color: var(--text-secondary);
  background: rgba(255, 255, 255, 0.02);
  padding-left: 15px;
}

.sidebar__sub-nav-item.active {
  color: var(--text-primary);
  background: var(--bg-glass-hover);
  font-weight: 600;
  padding-left: 15px;
}

/* ── Sidebar Action Buttons ── */
.sidebar__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
  padding-top: 15px;
  border-top: 1px solid var(--border-subtle);
}

.sidebar__btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.sidebar__btn--primary {
  background: rgba(16, 185, 129, 0.1);
  color: var(--accent-emerald);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.sidebar__btn--primary:hover {
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.3);
  color: var(--accent-emerald-hover);
  transform: translateY(-1px);
}

.sidebar__btn--secondary {
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
}

.sidebar__btn--secondary:hover {
  background: var(--bg-glass-hover);
  border-color: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

/* ── Bottom Profile Section ── */
.sidebar__footer {
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid var(--border-subtle);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sidebar__profile-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--gradient-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.95rem;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.08);
  box-shadow: var(--shadow-sm);
}

.sidebar__profile-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sidebar__profile-name {
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--text-primary);
}

.sidebar__profile-badge {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--accent-emerald);
  background: var(--accent-emerald-glow);
  padding: 1px 6px;
  border-radius: 4px;
  width: max-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sidebar__footer-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.sidebar__footer-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
  border-radius: var(--radius-sm);
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  transition: all 0.2s ease;
}

.sidebar__footer-btn:hover {
  color: var(--text-primary);
  background: var(--bg-glass-hover);
  border-color: rgba(255, 255, 255, 0.08);
}

.sidebar__footer-btn--danger:hover {
  color: var(--accent-rose);
  background: rgba(239, 68, 68, 0.06);
  border-color: rgba(239, 68, 68, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,6CAA6C;EAC7C,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,oCAAoC;AACtC","sourcesContent":[".sidebar {\n  width: 260px;\n  background-color: var(--bg-sidebar);\n  border-right: 1px solid var(--border-subtle);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  padding: 24px;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 10;\n  overflow-y: auto;\n}\n\n/* ── Brand logo ── */\n.sidebar__brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.sidebar__logo {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 3px;\n  width: 22px;\n  height: 22px;\n}\n\n.sidebar__logo-dot {\n  background-color: var(--accent-emerald);\n  border-radius: 2px;\n  transition: all 0.3s ease;\n}\n\n.sidebar__brand:hover .sidebar__logo-dot {\n  transform: scale(1.1);\n  filter: drop-shadow(0 0 4px var(--accent-emerald));\n}\n\n.sidebar__brand-name {\n  font-family: var(--font-family);\n  font-weight: 700;\n  font-size: 1.35rem;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n}\n\n/* ── Sidebar Search ── */\n.sidebar__search-container {\n  margin-bottom: 20px;\n}\n\n.sidebar__search-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.sidebar__search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.sidebar__search-input {\n  width: 100%;\n  padding: 10px 12px 10px 38px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-family: var(--font-sans);\n  transition: all 0.3s ease;\n}\n\n.sidebar__search-input:focus {\n  border-color: var(--border-active);\n  background: var(--bg-glass-hover);\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.08);\n  outline: none;\n}\n\n/* ── Navigation Links ── */\n.sidebar__nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.sidebar__menu-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar__nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 12px;\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  text-align: left;\n}\n\n.sidebar__nav-item-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sidebar__nav-item:hover {\n  background: var(--bg-glass-hover);\n  color: var(--text-primary);\n}\n\n.sidebar__nav-item--parent.expanded {\n  color: var(--text-primary);\n}\n\n.sidebar__nav-item-icon {\n  transition: transform 0.3s ease;\n}\n\n.sidebar__nav-item:hover .sidebar__nav-item-icon {\n  transform: translateX(1px);\n}\n\n.sidebar__arrow {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--text-muted);\n}\n\n.sidebar__arrow.rotated {\n  transform: rotate(180deg);\n  color: var(--text-primary);\n}\n\n/* Sub Navigation Menu */\n.sidebar__sub-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-left: 28px;\n  margin-top: 4px;\n  border-left: 1px solid var(--border-subtle);\n  margin-left: 20px;\n}\n\n.sidebar__sub-nav-item {\n  width: 100%;\n  text-align: left;\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  font-size: 0.88rem;\n  font-weight: 400;\n  transition: all 0.2s ease;\n}\n\n.sidebar__sub-nav-item:hover {\n  color: var(--text-secondary);\n  background: rgba(255, 255, 255, 0.02);\n  padding-left: 15px;\n}\n\n.sidebar__sub-nav-item.active {\n  color: var(--text-primary);\n  background: var(--bg-glass-hover);\n  font-weight: 600;\n  padding-left: 15px;\n}\n\n/* ── Sidebar Action Buttons ── */\n.sidebar__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 20px 0;\n  padding-top: 15px;\n  border-top: 1px solid var(--border-subtle);\n}\n\n.sidebar__btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.sidebar__btn--primary {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--accent-emerald);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.sidebar__btn--primary:hover {\n  background: rgba(16, 185, 129, 0.15);\n  border-color: rgba(16, 185, 129, 0.3);\n  color: var(--accent-emerald-hover);\n  transform: translateY(-1px);\n}\n\n.sidebar__btn--secondary {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  color: var(--text-primary);\n}\n\n.sidebar__btn--secondary:hover {\n  background: var(--bg-glass-hover);\n  border-color: rgba(255, 255, 255, 0.12);\n  transform: translateY(-1px);\n}\n\n/* ── Bottom Profile Section ── */\n.sidebar__footer {\n  margin-top: auto;\n  padding-top: 15px;\n  border-top: 1px solid var(--border-subtle);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.sidebar__profile-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sidebar__avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--gradient-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.08);\n  box-shadow: var(--shadow-sm);\n}\n\n.sidebar__profile-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.sidebar__profile-name {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.sidebar__profile-badge {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--accent-emerald);\n  background: var(--accent-emerald-glow);\n  padding: 1px 6px;\n  border-radius: 4px;\n  width: max-content;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sidebar__footer-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.sidebar__footer-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  border-radius: var(--radius-sm);\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  transition: all 0.2s ease;\n}\n\n.sidebar__footer-btn:hover {\n  color: var(--text-primary);\n  background: var(--bg-glass-hover);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.sidebar__footer-btn--danger:hover {\n  color: var(--accent-rose);\n  background: rgba(239, 68, 68, 0.06);\n  border-color: rgba(239, 68, 68, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
